import { useCallback, useState, type MouseEvent } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

import { Button } from '@simplywallst/ui-core';

import { useTranslation } from '@/hooks/useTranslation';

import StarOutline from '@simplywallst/ui-core/icons/StarOutline';

const GuestRegistrationModal = loadable(
  () => import('@/components/GuestRegistrationModal')
);

type Props = {
  onClick?: (e: MouseEvent) => void;
};

export const WatchlistGuestRegistration = ({ onClick }: Props) => {
  const t = useTranslation();
  const label = t('page.companyReport.header.actions.addToWatchlist');

  const { trackEvent } = useTracking();
  const [showRegistration, setShowRegistration] = useState(false);

  const handleLoggedOutAddClick = useCallback(() => {
    setShowRegistration(true);
    trackEvent({
      type: 'track',
      action: 'click',
      modifier: 'addToWatchlists',
      subject: 'guestRegistrationModal',
    });
  }, [trackEvent]);

  return (
    <>
      <div
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
        }}
      >
        {showRegistration && (
          <GuestRegistrationModal
            canClose={true}
            removeWindowScroll={true}
            onClose={() => setShowRegistration(false)}
            onRegisterSuccess={() => {
              trackEvent({
                type: 'track',
                subject: 'addToWatchLists',
                modifier: 'registration',
                action: 'success',
              });
            }}
          />
        )}
      </div>
      <Button
        styleType="louder"
        alignIcon="left"
        onClick={(e: MouseEvent) => {
          onClick?.(e);
          handleLoggedOutAddClick();
        }}
      >
        <StarOutline
          fill="white"
          data-cy-id="outline-star"
          role="presentation"
        />
        {label}
      </Button>
    </>
  );
};
